import axios from "axios";
import Config from "@/Config.js";

const BASE = Config.host + "sites";
const BASE_CAT = Config.host + "categories";

export default {
  getAll() {
    return axios.get(`${BASE}`).then((r) => r.data);
  },
  getById(id) {
    return axios.get(`${BASE}/${id}`).then((r) => r.data);
  },
  search(payload) {
    return axios.post(`${BASE}/search`, payload).then((r) => r.data);
  },
  save(site) {
    return axios.post(`${BASE}/save`, site).then((r) => r.data);
  },
  delete(id) {
    return axios.delete(`${BASE}/delete/${id}`).then((r) => r.data);
  },
  addView(id) {
    return axios.post(`${BASE}/${id}/view`).then((r) => r.data);
  },
  getImages(id) {
    return axios.get(`${BASE}/${id}/images`).then((r) => r.data);
  },
  saveImage(id, base64) {
    return axios.post(`${BASE}/${id}/images/save`, { idEntity: id, path: base64 }).then((r) => r.data);
  },
  deleteImage(idImage) {
    return axios.delete(`${BASE}/images/delete/${idImage}`).then((r) => r.data);
  },

  // Categorías
  getCategoriesByEntityType(entityType) {
    return axios
      .get(`${BASE_CAT}/byEntityType`, { params: { entityType } })
      .then((r) => r.data);
  },
  saveCategory(category) {
    return axios.post(`${BASE_CAT}/save`, category).then((r) => r.data);
  },
  deleteCategory(id) {
    return axios.delete(`${BASE_CAT}/delete/${id}`).then((r) => r.data);
  },
};
